import React, { useCallback, useContext, useEffect, useRef } from 'react';
import { classnames, noop } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { useScrollerBar } from '../../hooks/table';
export var TableScrollBarContext = React.createContext({
  setInfo: noop
});
export function TableScrollerBar(props) {
  var className = props.className,
      fixed = props.fixed;
  var scrollBarContext = useContext(TableScrollBarContext);
  var ref = useRef(null);

  var _useScrollerBar = useScrollerBar(function (s) {
    if (ref.current) {
      ref.current.scrollLeft = s;
    }
  }),
      width = _useScrollerBar.width,
      scrollerWidth = _useScrollerBar.scrollerWidth,
      scroll = _useScrollerBar.scroll,
      onScrollChange = _useScrollerBar.onScrollChange;

  useEffect(function () {
    if (ref.current && ref.current.scrollLeft !== scroll) {
      ref.current.scrollLeft = scroll;
    }
  });
  useEffect(function () {
    scrollBarContext.setInfo({
      tableWidth: width,
      scrollWidth: scrollerWidth,
      scroll: scroll
    });
  }, [width, scrollerWidth]);
  var onScroll = useCallback(function (e) {
    if (e.currentTarget !== e.target) {
      return;
    }

    onScrollChange(e.target.scrollLeft);
  }, []);
  var cls = classnames(usePrefixCls('table-scroller-bar', {
    hide: width >= scrollerWidth,
    fixed: fixed
  }), className);
  var innerCls = usePrefixCls('table-scroller-bar-inner');
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    ref: ref,
    className: innerCls,
    onScroll: onScroll,
    style: {
      width: "".concat(width, "px")
    }
  }, React.createElement("div", {
    style: {
      width: "".concat(scrollerWidth, "px")
    }
  })));
}